{
    "account_delete.heading": "Supprimer mes données",
    "account_request_data.heading": "Demander mes données",
    "action.cancel": "Annuler",
    "action.pinned": "Épinglé",
    "action.report": "Signaler",
    "appError.goHome": "Retourner",
    "appError.page_forbidden": "Votre compte ne peut pas accéder à cette page.",
    "appError.page_not_found": "La page que vous recherchez n'existe pas.",
    "appError.page_unauthorized": "Vous n'avez pas la permission d'accéder à cette page.",
    "article.zdf_section": "ZDF",
    "audience_input.community_guidelines_title": "Directives Communautaires",
    "audience_input.your_reply_label": "Votre réponse",
    "blocklist.single_term_not_deleted": "Le terme de la liste de blocage n’a pas pu être supprimé",
    "blocklist.terms_not_added_duplicate": "Le terme de la liste de blocage existe déjà : {duplicateTerms}",
    "blocklist.terms_not_added_mixed": "Le terme de la liste de blocage existe déjà : {duplicateTerms}. Le terme de la liste de blocage n’a pas pu être ajouté, veuillez réessayer : {refusedTerms}",
    "blocklist.terms_not_added_refused": "Le terme de la liste de blocage n’a pas pu être ajouté, veuillez réessayer : {refusedTerms}",
    "blocklist.terms_not_deleted": "{failedCount} termes de la liste de blocage sur {totalCount} n’ont pas pu être supprimés",
    "button.react": "Réagir",
    "button.react_button_selected": "sélectionné",
    "button.reacted": "Réagi",
    "byline.deleted_user": "Utilisateur supprimé",
    "byline.edited": "Modifié",
    "close_conversation.closed_message": "Cette conversation est désormais fermée.",
    "comment.cancel_button": "Annuler",
    "comment.delete_modal_heading": "Êtes-vous sûr de vouloir supprimer ce post ?",
    "comment.delete_modal_warning": "Cette action ne peut pas être annulée.",
    "comment.edit_button": "Modifier",
    "comment.posting": "Publication en cours...",
    "comment.read_more_button": "Lire la suite",
    "comment.reply_button": "Réponse",
    "comment.report_button": "Signaler",
    "comment.show_less": "Afficher moins",
    "comment.show_more_replies_plural": "Afficher {count} réponses de plus",
    "comment.show_more_reply_singular": "Afficher {count} réponse de plus",
    "comment.show_translation": "Afficher la traduction ({language})",
    "comment.update_button": "Mettre à jour",
    "comment.your_reply_label": "Votre réponse",
    "comment_feedback.only_visible_to_you": "Visible uniquement par vous",
    "comment_slider.community_guidelines_title": "Directives Communautaires",
    "comment_slider.public_response": "Réponse publique",
    "comment_slider.response": "réponse",
    "comment_slider.responses": "réponses",
    "comment_slider.your_reply_label": "Votre réponse",
    "comment_slider_editable_positions.heading": "Personnaliser le curseur de commentaires",
    "common.are": "sont",
    "common.download": "Télécharger",
    "common.is": "est",
    "community_guidelines.title": "Directives Communautaires",
    "context_entry_points.From": "De",
    "cta_button.loading": "Chargement",
    "date.days_abbrev": "{days}j",
    "date.hours_abbrev": "{hours}h",
    "date.minutes_abbrev": "{minutes}min.",
    "date.months_abbrev": "{months}mois",
    "date.now": "maintenant",
    "date.years_abbrev": "{years}année",
    "editable_positions_widget.button_label": "Modifier les positions",
    "editable_positions_widget.label": "Position #{position}",
    "editorial_question.be_first": "Soyez le premier à partager vos réflexions",
    "editorial_question.count_noun": "{count} {noun}",
    "editorial_question.response_singular": "réponse",
    "editorial_question.responses_plural": "réponses",
    "error.api": "Quelque chose s'est mal passé",
    "error.network": "Erreur réseau - Veuillez vérifier votre connexion à Internet et réessayer.",
    "footer.made_by": "Fait par ",
    "form.accordion.hide_details": "Masquer les détails",
    "form.accordion.show_details": "Afficher les détails",
    "form.adding_button": "Ajout en cours...",
    "form.cancel_button": "Annuler",
    "form.uncheck_all": "Tout décocher",
    "form.update_button": "Mettre à jour",
    "format.count_noun": "{count} {noun}",
    "language.de-CH": "Allemand (Suisse)",
    "language.de-DE": "Allemand",
    "language.en-US": "Anglais",
    "language.fr-BE": "Français (Belgique)",
    "language.fr-CA": "Français (Canada)",
    "language.fr-CH": "Français (Suisse)",
    "language.fr-FR": "Français",
    "language.it-CH": "Italien (Suisse)",
    "language.it-IT": "Italien",
    "language.nl-NL": "Néerlandais",
    "language.rm-CH": "Romanche (Suisse)",
    "legal.privacy_notice": "Avis de confidentialité",
    "legal.terms_of_service": "Conditions d'utilisation",
    "linked_partner_story.incomplete_list_banner": "Cette liste d'articles peut être incomplète.",
    "linked_partner_story.linked_articles_description": "Voir les articles attachés à cette conversation.",
    "linked_partner_story.linked_articles_heading": "Articles liées",
    "linked_partner_story.no_articles_found": "Il n'y a pas encore d'articles liés à cet espace.",
    "linked_partner_story.read_article_link": "Lire l'article",
    "linked_partner_story.view_video_link": "Voir la vidéo",
    "loading": "Chargement...",
    "login.continue_with_google": "Continuer avec Google",
    "login.default_admin_login_heading_label": "Bienvenue sur {psiBrandName}",
    "login.default_login_heading_label": "Un espace pour des discussions saines et des perspectives variées",
    "login.dev_login": "Connexion Dév",
    "login.okay_button": "D’accord",
    "login.select_dev_persona": "Sélectionner un persona dév",
    "login.sso_error": "Une erreur s'est produite lors de la connexion. Veuillez fermer cette fenêtre et réessayer.",
    "modal.cancel_button": "Annuler",
    "modal.confirm_leave_button": "Quitter",
    "moderation.admin_bypass_ai_and_manual_moderation": "Cet espace dispose d'une modération par IA et humaine activée, mais vous contournerez automatiquement les deux en tant qu'utilisateur Admin.",
    "moderation.admin_bypass_ai_moderation": "Cet espace dispose d'une modération par IA activée, mais vous la contournerez automatiquement en tant qu'utilisateur Admin.",
    "moderation.admin_bypass_manual_moderation": "Cet espace dispose d'une modération humaine activée, mais vous la contournerez automatiquement en tant qu'utilisateur Admin.",
    "moderation.admin_filter_notice": "Pour contribuer à l'amélioration de la modération par l'IA, veuillez envoyer une capture d'écran de votre publication et de ce message à votre équipe.",
    "moderation.ai_and_manual_label": "Modéré par IA et manuellement",
    "moderation.approved_tag": "Approuvé",
    "moderation.automaticallyApproved": "Approuvé automatiquement",
    "moderation.awaitingDecision": "En attente de décision",
    "moderation.blocked": "Bloqué",
    "moderation.bypassedPremoderation": "Contourné la prémodération",
    "moderation.dash.approve": "Approuver",
    "moderation.dash.base_filter._rejected": "Rejeté manuellement",
    "moderation.dash.base_filter.auto_approved": "Approuvé automatiquement",
    "moderation.dash.base_filter.awaiting_decision": "En attente de décision",
    "moderation.dash.reject": "Rejeter",
    "moderation.deletedByUser": "Supprimé par l'utilisateur",
    "moderation.deletedUser": "Utilisateur supprimé",
    "moderation.heated": "Chaud",
    "moderation.infoBannerLoader.label": "Examen de votre réponse...",
    "moderation.info_ai_and_manual_moderation_banner_text": "Pour maintenir un environnement accueillant et respectueux, tous les posts dans cet espace sont modérés à la fois par IA et manuellement avant publication afin de garantir qu'ils respectent les [Règles de la communauté]($onPress)",
    "moderation.info_manual_moderation_banner_text": "Pour maintenir un environnement accueillant et respectueux, tous les posts dans cet espace sont modérés manuellement avant publication afin de respecter les [Règles de la communauté]($onPress)",
    "moderation.liveThread": "Suivi en direct",
    "moderation.manuallyApproved": "Approuvé manuellement",
    "moderation.manuallyRejected": "Rejeté manuellement",
    "moderation.mode_manual": "Modération manuelle",
    "moderation.new": "Nouveau",
    "moderation.popular": "Populaire",
    "moderation.postedAnyway": "Publié quand même",
    "moderation.rejected_by_moderator": "Rejeté par un modérateur",
    "moderation.select_all_that_apply": "Sélectionnez toutes les options applicables.",
    "moderation.sent_to_moderator_time": "Envoyé au modérateur : {time}",
    "moderation.singularTerm": "Terme singulier",
    "moderation.system_unavailable_message": "Notre système de modération AI est temporairement indisponible. Vous pouvez toujours envoyer votre publication à un modérateur humain pour révision.",
    "moderation.system_unavailable_title": "⚠️ Système de modération temporairement indisponible",
    "moderation.warned": "Averti",
    "moderation.zdfComment": "Commentaire ZDF",
    "moderation_card.language_tag": "{locale} | Traduit",
    "most_popular.show_more_button": "Afficher plus de réponses",
    "notification.dismiss_button": "Ignorer",
    "onboarding.dismiss_button": "Ignorer",
    "pagination_row.previous_page": "Page précédente",
    "pagination_row.showing": "Affichage de {start}-{end} sur {total}",
    "perspectives.add_new_perspective": "Ajouter une nouvelle perspective",
    "perspectives.add_your_perspective": "Ajoutez votre perspective",
    "perspectives.havent_heard_yet": "Nous n’avons pas encore entendu ces perspectives",
    "perspectives.poll_title": "De qui nous avons entendu parler",
    "perspectives.title": "Perspectives",
    "pin_to_feed.move_down": "Descendre",
    "pin_to_feed.move_up": "Monter",
    "popup.close_button": "Fermer la fenêtre",
    "popup_tip.more_information": "Plus d'informations",
    "post.post_anyway_button": "Publier quand même",
    "post.posting_anyway": "Publication quand même...",
    "post.submit": "Soumettre",
    "post.submitting": "Soumission...",
    "post.update": "Mettre à jour",
    "post.update_anyway_button": "Mettre à jour quand même",
    "post.updating": "Mise à jour...",
    "post.updating_anyway": "Mise à jour quand même...",
    "profile.edit.custom-title": "Ajouter un titre personnalisé",
    "profile.edit.custom_title": "Ajoutez un titre personnalisé",
    "profile.edit.name": "Nom du profil",
    "profile.edit.name_override": "Nom",
    "profile.edit.name_override.placeholder": "Ajoutez votre nom de remplacement...",
    "profile.edit.override_name_title": "Remplacer le nom du profil",
    "profile.edit.override_photo_title": "Remplacer la photo du profil",
    "profile.edit.photo": "Photo du profil",
    "profile.edit.photo_override": "URL de la photo",
    "profile.edit.photo_override.placeholder": "Ajoutez votre URL de remplacement...",
    "profile.edit.title": "Titre",
    "profile.finish_button": "Terminé",
    "profile.go_to.edit": "Modifier les remplacements",
    "profile.loading": "Chargement du profil...",
    "profile.module_name": "nom",
    "profile.name_label": "Nom du profil",
    "profile.no_user_error": "Aucun utilisateur de ce type",
    "profile.please_wait": "Veuillez patienter...",
    "profile.public_overriden": "Vos informations ont été modifiées par un administrateur",
    "profile.setup_title": "Configurez votre profil",
    "profile.title_placeholder": "Entrer le titre",
    "profile.username_placeholder": "utilisateur123",
    "profile_answers.edit_visibility": "Modifier la visibilité",
    "profile_menu.dialog_label": "Menu du profil",
    "profile_menu.menu_label": "Compte",
    "question.actions.close_modal_description": "Quand fermée, une espace devient \"lecture seule.\" La plupart des actions sont désactivées et les utilisateurs ne peuvent pas poster, répondre ou réagir. Les utilisateurs peuvent encore signaler des commentaires. Vous pouvez rouvrir la conversation à tout moment.",
    "question.actions.close_modal_heading": "Fermer cet espace ?",
    "question.actions.edit_button": "Modifier",
    "question.actions.link_copied_toast": "Lien copié dans le presse-papiers !",
    "question.actions.linked_stories_button": "Aricles liés",
    "question.actions.preview_button": "Prévisualiser",
    "question.actions.reopen_modal_heading": "Réouvrir cet espace ?",
    "question.actions.tooltip": "Plus d'options",
    "question.conversation_format": "Format de la conversation",
    "question.conversation_type_section": "Type de conversation",
    "question.count_noun_format": "{count} {noun}",
    "question.error_empty_prompt": "Ce champ est obligatoire",
    "question.error_prompt_too_long": "Le champ doit comporter moins de {num} caractères.",
    "question.general_section": "Général",
    "question.no_comments_message": "Soyez le premier à partager vos réflexions",
    "question.no_comments_title": "Lancez la conversation",
    "question.no_teaser_error": "Aucun teaser défini",
    "question.prosocial_ranking_section": "Classement prosocial",
    "question.public_response_subtitle": "Réponse publique",
    "question.reaction_list_tooltip": "Voir les réactions",
    "question.reaction_plural": "réactions",
    "question.reaction_singular": "réaction",
    "question.reply_placeholder": "Répondre à {authorName}...",
    "question.upvote_plural": "votes positifs",
    "reaction_types.appreciation_plural": "appréciations",
    "reaction_types.appreciation_singular": "appréciation",
    "reaction_types.constructive": "Constructif",
    "reaction_types.count_noun": "{count} {noun}",
    "reaction_types.default_set": "Ensemble par défaut",
    "reaction_types.fun_space": "Espace amusant",
    "reaction_types.helpful": "Utile",
    "reaction_types.insightful": "Intéressant",
    "reaction_types.interesting": "Intéressant",
    "reaction_types.personal_space": "Espace personnel",
    "reaction_types.serious_space": "Espace sérieux",
    "reaction_types.surprising": "Surprenant",
    "related_content.article_option": "Article",
    "related_content.audio_option": "Audio",
    "related_content.learn_more": "En savoir plus sur ce sujet",
    "related_content.url_placeholder": "https://www.exemple.com",
    "related_content.video_option": "Vidéo",
    "related_conversations.add_spaces_button": "Ajouter des espaces",
    "related_conversations.next_button": "Suivant",
    "related_conversations.no_spaces_found": "Aucun espace trouvé",
    "related_conversations.participant_count": "{count} {noun}",
    "related_conversations.previous_button": "Précédent",
    "related_conversations.title": "Conversations connexes",
    "satisfaction_survey_popover.satisfied_label": "Très satisfait",
    "satisfaction_survey_popover.unsatisfied_label": "Très pas satisfait",
    "single_response_help.same_question_title": "Même question, nouvel article?",
    "sort_button.aria_label": "Trier par {text}",
    "sort_menu.sort_by_header": "Trier par",
    "space.detail.id": "ID :",
    "space.detail.posts": "Publications :",
    "srg.profile.error_name_invalid": "Les noms personnalisés peuvent uniquement inclure des lettres, des chiffres, des espaces et des tirets.",
    "standalone_question.participant": "participant",
    "standalone_question.participants": "participants",
    "status.reported": "Signalé",
    "story_dash.date_column": "Publié",
    "story_dash.remove_modal_description": "Cette action ne peut pas être annulée. Tout espace attaché sera détaché.",
    "story_dash.remove_modal_description_2": "Vous pouvez ajouter l'histoire à nouveau à tout moment et l'attacher à un espace.",
    "story_dash.remove_modal_heading": "Supprimer cette histoire ?",
    "survey.feedback_help": "Vos commentaires nous aideront à améliorer votre expérience.",
    "survey.tell_us_experience": "Parlez-nous de votre expérience",
    "survey.thank_you": "Merci d'avoir partagé votre expérience avec nous !",
    "text.character_count": "{count}/{max} caractères",
    "text.character_count_max": "{count}/{max} caractères max",
    "text.character_count_min": "{min} caractères min",
    "text.character_count_over_max": "{count}/{max} caractères max",
    "text.character_count_progress_min": "{count}/{min} caractères min",
    "tile.experimental_label": "Bêta",
    "tile.outdated_label": "Obsolète",
    "upvote.aria_label": "Vote positif",
    "user_info.account_button": "Compte",
    "user_info.faqs": "FAQs",
    "user_info.log_out_button": "Se déconnecter",
    "user_info.profile_button": "Profil",
    "user_info.profile_menu_aria_label": "Menu du profil pour {name}",
    "videovoting.select_chapter": "Sélectionnez un chapitre",
    "videovoting.select_existing_voting": "Sélectionnez un vote vidéo existant",
    "videovoting.select_question": "Sélectionnez une question",
    "visibility.only_visible_to_admins": "Visible uniquement par les administrateurs",
    "vote.delete_button": "Supprimer",
    "vote.delete_modal_heading": "Êtes-vous sûr de vouloir supprimer votre vote ?",
    "vote.delete_modal_warning": "Cette action est irréversible."
}
